/** @format */

const template = `
<label class="sis-radio control control-radio" ng-class="{'control-inline': inline}"
  >{{label|translate}}
  <input type="radio" ng-model="ngModel" ng-change="cb({value: ngValue})" ng-value="ngValue" ng-disabled="disabled" />
  <div class="control-indicator"></div>
</label>
`;
export default template;
